import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { AppThunk } from "../../../../../store/app";
import api from "../../../../../store/api";
import API_URL from "../../../../../config/ApiUrl";
import { setUserOptions } from "../../../../../store/AuthSlice";

interface UserProfileState {
  userProfile: any;
  appLoading: boolean;
  race: any;
  veteran: any;
  vrTraining: any;
  startExam: any;
  interestAssment: any;
  skillAssessment: any;
  examListData: any;
  bothExamData: any;
  perPageSize: any;
  grid: any;
  profileProgress: any;
  masterDropDown: any;
  goSkillModal: boolean;
  examResultData: any;
  careerList: any;
  pagination: any;
  savedJobList: any;
  acronymsList: any;
  industryList: any;
  criticalCareerList: any;
  trainingCertificateList: any;
  trialInterestAssment: any;
  count?: number;
  saveCount?: number;
  skillSuccessPopup?: boolean;
}

const initialState = {
  userProfile: null,
  appLoading: true,
  race: [],
  veteran: [],
  vrTraining: [],
  startExam: null,
  interestAssment: null,
  skillAssessment: null,
  examListData: null,
  bothExamData: null,
  perPageSize: null,
  grid: null,
  profileProgress: null,
  masterDropDown: [],
  goSkillModal: false,
  examResultData: null,
  careerList: [],
  savedJobList: [],
  acronymsList: [],
  industryList: [],
  criticalCareerList: [],
  pagination: {
    current_page: 0,
    last_page: 0,
    per_page: 0,
    total: 0,
  },
  trainingCertificateList: [],
  trialInterestAssment: null,
  count: 0,
  saveCount: 0,
  skillSuccessPopup: false,
} as UserProfileState;

const WebProfileSlice = createSlice({
  name: "WEBPROFILE",
  initialState,
  reducers: {
    setUserProfile: (state, action: PayloadAction<any>) => {
      state.userProfile = action.payload;
    },
    setAppLoading: (state, action: PayloadAction<boolean>) => {
      state.appLoading = action.payload;
    },
    setRace: (state, action: PayloadAction<any>) => {
      state.race = action.payload;
    },
    setveteran: (state, action: PayloadAction<any>) => {
      state.veteran = action.payload;
    },
    setVrTraining: (state, action: PayloadAction<any>) => {
      state.vrTraining = action.payload;
    },
    setStartExam: (state, action: PayloadAction<any>) => {
      state.startExam = action.payload;
    },
    setInterestAssessment: (state, action: PayloadAction<any>) => {
      state.interestAssment = action.payload;
    },
    setSkillAssessment: (state, action: PayloadAction<any>) => {
      state.skillAssessment = action.payload;
    },
    setExamListData: (state, action: PayloadAction<any>) => {
      state.examListData = action.payload;
    },
    setBothExamData: (state, action: PayloadAction<any>) => {
      state.bothExamData = action.payload;
    },
    setPerPageSize: (state, action: PayloadAction<any>) => {
      state.perPageSize = action.payload;
      if (state.grid) {
        state.grid.api.paginationSetPageSize(Number(state.perPageSize));
        state.grid.api.setCacheBlockSize(state.perPageSize);
      }
    },
    setGrid: (state, action: PayloadAction<any>) => {
      state.grid = action.payload;
    },
    setMasterDropDown: (state, action: PayloadAction<any>) => {
      state.masterDropDown = action.payload;
    },
    setGoSkillModal: (state, action: PayloadAction<any>) => {
      state.goSkillModal = action.payload;
    },
    setExamResultData: (state, action: PayloadAction<any>) => {
      state.examResultData = action.payload;
    },
    setCareerListData: (
      state,
      action: PayloadAction<{ rows: any[]; page: number; pagination?: any; count?: number; }>,
    ) => {
      if (action.payload.page === 1) {
        state.careerList = action.payload.rows;
      } else {
        state.careerList = [
          ...(state.careerList || []),
          ...action.payload.rows,
        ];
      }
      state.pagination = action.payload.pagination;
      state.count = action.payload.count || 0;
    },
    setSavedJobList: (state, action: PayloadAction<{ rows: any[]; page: number; pagination?: any; count?: number }>) => {
      if (action.payload.page === 1) {
        state.savedJobList = action.payload.rows;
      } else {
        state.savedJobList = [
          ...(state.savedJobList || []),
          ...action.payload.rows,
        ];
      }
      state.pagination = action.payload.pagination;
      state.saveCount = action.payload.count || 0;
    },
    setAcronymsListData: (state, action: PayloadAction<any>) => {
      state.acronymsList = action.payload;
    },
    setIndustryListData: (state, action: PayloadAction<any>) => {
      state.industryList = action.payload;
    },
    setcriticalCareerList: (state, action: PayloadAction<any>) => {
      state.criticalCareerList = action.payload;
    },
    setTrainingCertificate: (state, action: PayloadAction<any>) => {
      state.trainingCertificateList = action.payload;
    },
    setTrialInterestAssessment: (state, action: PayloadAction<any>) => {
      state.trialInterestAssment = action.payload;
    },
    setskillSuccessPopup: (state, action: PayloadAction<any>) => {
      state.skillSuccessPopup = action.payload;
    },
  },
});

export const {
  setUserProfile,
  setExamResultData,
  setAppLoading,
  setGoSkillModal,
  setRace,
  setveteran,
  setVrTraining,
  setStartExam,
  setGrid,
  setInterestAssessment,
  setPerPageSize,
  setBothExamData,
  setSkillAssessment,
  setExamListData,
  setMasterDropDown,
  setCareerListData,
  setSavedJobList,
  setAcronymsListData,
  setIndustryListData,
  setcriticalCareerList,
  setTrainingCertificate,
  setTrialInterestAssessment,
  setskillSuccessPopup
} = WebProfileSlice.actions;

export const updateProfile =
  (data: string): AppThunk<any> =>
    async (dispatch) => {
      try {
        dispatch(setAppLoading(true));
        const response = await api.post(API_URL.UPDATEPROFILE, data);
        dispatch(setUserProfile(response.data));
        // dispatch(setUserOptions());
        dispatch(setAppLoading(false));
        return Promise.resolve(response.data.rows);
      } catch (error: any) {
        dispatch(setAppLoading(false));
        dispatch(setUserProfile([]));
        return Promise.reject(error.data);
      }
    };

export const fetchRaceList = (): AppThunk<any> => async (dispatch) => {
  try {
    dispatch(setAppLoading(true));
    const response = await api.get(API_URL.RACE);
    const customizeObject = response.data.data?.sort((a: any, b: any) => b.id - a.id)
    dispatch(setRace(customizeObject));
    dispatch(setAppLoading(false));
    return Promise.resolve(customizeObject);
  } catch (error: any) {
    dispatch(setAppLoading(false));
    dispatch(setRace([]));
    return Promise.reject(error.data);
  }
};
export const fetchVeteranList = (): AppThunk<any> => async (dispatch) => {
  try {
    dispatch(setAppLoading(true));
    const response = await api.get(API_URL.VETERAN);
     const customizeObject = response.data.data?.sort((a: any, b: any) => b.id - a.id)
    dispatch(setRace(customizeObject));
    dispatch(setveteran(customizeObject));
    dispatch(setAppLoading(false));
    return Promise.resolve(customizeObject);
  } catch (error: any) {
    dispatch(setAppLoading(false));
    dispatch(setveteran([]));
    return Promise.reject(error.data);
  }
};
export const fetchVrTraining = (): AppThunk<any> => async (dispatch) => {
  try {
    dispatch(setAppLoading(true));
    const response = await api.get(API_URL.VR_TRAINING);
    dispatch(setVrTraining(response.data.data));
    dispatch(setAppLoading(false));
    return Promise.resolve(response.data);
  } catch (error: any) {
    dispatch(setAppLoading(false));
    dispatch(setveteran([]));
    return Promise.reject(error.data);
  }
};
export const startExam =
  (data: any): AppThunk<any> =>
    async (dispatch) => {
      try {
        dispatch(setAppLoading(true));
        const response = await api.post(API_URL.EXAM_START, data);
        dispatch(setStartExam(response.data.data));
        dispatch(setAppLoading(false));
        return Promise.resolve(response.data);
      } catch (error: any) {
        dispatch(setAppLoading(false));
        dispatch(setStartExam(null));
        return Promise.reject(error.data);
      }
    };
export const fetchInterestAssessment =
  (): AppThunk<any> => async (dispatch) => {
    try {
      dispatch(setAppLoading(true));
      const response = await api.get(API_URL.INTEREST_ASSESSMENT);
      dispatch(setInterestAssessment(response.data.data));
      dispatch(setBothExamData(response.data.data));
      dispatch(setAppLoading(false));
      return Promise.resolve(response.data);
    } catch (error: any) {
      dispatch(setAppLoading(false));
      dispatch(setInterestAssessment(null));
      dispatch(setBothExamData(null));
      return Promise.reject(error.data);
    }
  };
export const fetchSkillAssessment = (): AppThunk<any> => async (dispatch) => {
  try {
    dispatch(setAppLoading(true));
    const response = await api.get(API_URL.SKILL_ASSESSMENTU);
    dispatch(setSkillAssessment(response.data));
    dispatch(setBothExamData(response.data.data));
    dispatch(setAppLoading(false));
    return Promise.resolve(response.data);
  } catch (error: any) {
    dispatch(setAppLoading(false));
    dispatch(setSkillAssessment(null));
    dispatch(setBothExamData(null));
    return Promise.reject(error.data);
  }
};
export const submitAnswer =
  (id: any, data: any): AppThunk<any> =>
    async (dispatch) => {
      try {
        const response = await api.post(API_URL.SUBMIT_ANSWER(id), data);
        return Promise.resolve(response.data);
      } catch (error: any) {
        dispatch(setAppLoading(false));
        return Promise.reject(error.data);
      }
    };
export const tierOneSubmitAnswer =
  (id: any): AppThunk<any> =>
    async (dispatch) => {
      try {
        const response = await api.post(API_URL.TIER_ONE_SUBMIT_ANSWER(id));
        return Promise.resolve(response.data);
      } catch (error: any) {
        dispatch(setAppLoading(false));
        return Promise.reject(error.data);
      }
    };
export const finishExam =
  (id: any, data: any): AppThunk<any> =>
    async (dispatch) => {
      try {
        dispatch(setAppLoading(true));
        const response = await api.post(API_URL.FINISH_EXAM(id));
        dispatch(setAppLoading(false));
        dispatch(setUserOptions());
        if (data?.assessment_type === "2") {
          dispatch(setGoSkillModal(true));
        }
        else {
          dispatch(setskillSuccessPopup(true));
        }

        return Promise.resolve(response.data);
      } catch (error: any) {
        dispatch(setAppLoading(false));
        return Promise.reject(error.data);
      }
    };
export const getExamList =
  (data: any): AppThunk<any> =>
    async (dispatch) => {
      const payload = {
        assessment_type: data,
      };
      try {
        dispatch(setAppLoading(true));
        const response = await api.post(API_URL.EXAM_LIST, payload);
        dispatch(setAppLoading(false));
        dispatch(setExamListData(response.data));
        return Promise.resolve(response.data);
      } catch (error: any) {
        dispatch(setAppLoading(false));
        return Promise.reject(error.data);
      }
    };

export const getCriticalCareer = (data: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      dispatch(setAppLoading(true));
      const response = await api.get(API_URL.CRITICAL_CAREER_LIST, {
        params: { industry_id: data }
      });
      dispatch(setAppLoading(false));
      dispatch(setcriticalCareerList(response?.data));
      return Promise.resolve(response?.data);
    } catch (error: any) {
      dispatch(setAppLoading(false));
      return Promise.reject(error.data);
    }
  }

export const ViewIntersetExam =
  (id: any): AppThunk<any> =>
    async (dispatch) => {
      try {
        dispatch(setAppLoading(true));
        const response = await api.post(API_URL.VIEW_ASSEMENT(id));
        dispatch(setBothExamData(response.data.data));
        dispatch(setAppLoading(false));
        return Promise.resolve(response.data);
      } catch (error: any) {
        dispatch(setAppLoading(false));
        dispatch(setBothExamData(null));
        return Promise.reject(error.data);
      }
    };
export const disabledWelcomeModal = (): AppThunk<any> => async () => {
  try {
    const response = await api.post(API_URL.DISABLED_WELCOME_MODAL);
    return Promise.resolve(response.data);
  } catch (error: any) {
    return Promise.reject(error.data);
  }
};
export const masterLov =
  (param: any): AppThunk<any> =>
    async (dispatch) => {
      try {
        const response = await api.get(API_URL.MASTER_LOV_DATA(param));
        dispatch(setMasterDropDown(response.data.data));
        return Promise.resolve(response.data);
      } catch (error: any) {
        dispatch(setMasterDropDown([]));
        return Promise.reject(error.data);
      }
    };
export const examResult = (): AppThunk<any> => async (dispatch) => {
  try {
    const response = await api.post(API_URL.EXAM_RESULT);
    dispatch(setExamResultData(response.data.data));
    return Promise.resolve(response.data);
  } catch (error: any) {
    dispatch(setMasterDropDown([]));
    return Promise.reject(error.data);
  }
};
export const downloadReportPdf = (requestData: any): AppThunk<any> => async () => {
  try {
    const response = await api.post(API_URL.EXAM_RESULT_PDF, requestData);
    return Promise.resolve(response.data);
  } catch (error: any) {
    return Promise.reject(error.data);
  }
};

export const downloadTrialReportPdf = (requestData: any): AppThunk<any> => async () => {
  try {
    const response = await api.post(API_URL.TRIAL_EXAM_RESULT_PDF, requestData);
    return Promise.resolve(response.data);
  } catch (error: any) {
    return Promise.reject(error.data);
  }
};

export const fetchCareers =
  (
    search: any = "",
    career_category: any = null,
    page = 1,
    order = "ASC",
    min_salary: any = "",
    max_salary: any = "",
    sort_by: any = "",
  ): AppThunk<any> =>
    async (dispatch) => {
      try {
        const requestData = {
          category_id: career_category,
          search,
          page,
          per_page: 10,
          order,
          min_salary,
          max_salary,
          sort_by: sort_by || "name",
        };
        dispatch(setAppLoading(true));
        const response = await api.post(API_URL.CAREER_LIST, requestData);

        dispatch(setCareerListData({ rows: response.data.rows, page, pagination: response.data.pagination, count: response.data.count }));
        dispatch(setAppLoading(false));
        return Promise.resolve(response.data);
      } catch (error: any) {
        dispatch(setAppLoading(false));
        dispatch(setCareerListData({ rows: [], page: 1 }));
        return Promise.reject(error.data);
      }
    };

export const fetchCareerDetails =
  (career_id: any): AppThunk<any> =>
    async () => {
      try {
        const response = await api.get(API_URL.CAREER_DETAILS(career_id));
        return Promise.resolve(response.data);
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    };

export const fetchSavedJobs = (
  search: any = "",
  career_category: any = null,
  page = 1,
  order = "ASC",
  min_salary: any = "",
  max_salary: any = "",
  sort_by: any = "",
): AppThunk<any> => async (dispatch) => {
  try {
    const requestData = {
      category_id: career_category,
      search,
      page,
      per_page: 10,
      order,
      min_salary,
      max_salary,
      sort_by: sort_by || "name",
    };
    dispatch(setAppLoading(true));
    const response = await api.post(API_URL.MY_JOB_LIST, requestData);
    dispatch(setSavedJobList({ rows: response.data.rows, page, pagination: response.data.pagination, count: response.data.count }));
    dispatch(setAppLoading(false));
    return Promise.resolve(response.data);
  } catch (error: any) {
    dispatch(setAppLoading(false));
    dispatch(setSavedJobList({ rows: [], page: 1 }));
    return Promise.reject(error.data);
  }
};

export const fetchCareerCategorys = (): AppThunk<any> => async () => {
  try {
    const response = await api.get(API_URL.CAREER_CATEGORY_LIST);
    return Promise.resolve(response.data);
  } catch (error: any) {
    return Promise.reject(error.data);
  }
};

export const fetchCareerCategoryDetails =
  (cc_id: any): AppThunk<any> =>
    async () => {
      try {
        const response = await api.get(API_URL.CAREER_CATEGORY_DETAILS(cc_id));
        return Promise.resolve(response.data);
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    };

export const addRemoveJob =
  (requestData: any): AppThunk<any> =>
    async () => {
      try {
        const response = await api.post(API_URL.JOB_ADD_REMOVE, requestData);
        return Promise.resolve(response.data);
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    };

export const fetchAcronyms = (): AppThunk<any> => async (dispatch) => {
  try {
    dispatch(setAppLoading(true));
    const response = await api.get(API_URL.ACRONYM_LIST);
    dispatch(setAcronymsListData(response.data.rows));
    dispatch(setAppLoading(false));
    return Promise.resolve(response.data);
  } catch (error: any) {
    dispatch(setAppLoading(false));
    dispatch(setAcronymsListData([]));
    return Promise.reject(error.data);
  }
};

export const fetchAcronymDetails =
  (acronym_id: any): AppThunk<any> =>
    async () => {
      try {
        // <<<<<<< f-new-design-upgrade-2-0-brijesh
        const response = await api.get(API_URL.ACRONYM_DETAILS(acronym_id));
        // =======
        //         const response = await api.post(API_URL.SetUserSpecialExamFlag,requestData)
        // >>>>>>> f-new-design-upgrade-2-0
        return Promise.resolve(response.data);
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    };
export const setUserSpecialFlag =
  (requestData: any): AppThunk<any> =>
    async () => {
      try {
        console.log("requestData", requestData);
        const response = await api.post(
          API_URL.SetUserSpecialFlag,
          requestData
        );
        return Promise.resolve(response.data);
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    };



export const updateUsersIndustry =
  (requestData: any): AppThunk<any> =>
    async () => {
      try {
        const response = await api.post(
          API_URL.UPDATE_USER_INDUSTRY,
          requestData
        );
        return Promise.resolve(response.data);
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    };

export const fetchIndustryList = (): AppThunk<any> => async (dispatch) => {
  try {
    dispatch(setAppLoading(true));
    const response = await api.get(API_URL.INDUSTRY_LIST);
    dispatch(setIndustryListData(response.data.data));
    dispatch(setAppLoading(false));
    return Promise.resolve(response.data.data);
  } catch (error: any) {
    dispatch(setAppLoading(false));
    dispatch(setIndustryListData([]));
    return Promise.reject(error.data);
  }
};

export const fetchTrainingCertificate = (): AppThunk<any> => async (dispatch) => {
  try {
    dispatch(setAppLoading(true));
    const response = await api.get(API_URL.TRAINING_CERTIFICATE);
    dispatch(setTrainingCertificate(response.data.data));
    dispatch(setAppLoading(false));
    return Promise.resolve(response.data);
  } catch (error: any) {
    dispatch(setAppLoading(false));
    dispatch(setTrainingCertificate([]));
    return Promise.reject(error.data);
  }
};


/* Trial Exam Thunks  Start*/
export const startTrialExam =
  (): AppThunk<any> =>
    async (dispatch) => {
      try {
        dispatch(setAppLoading(true));
        const response = await api.get(API_URL.TRIAL_EXAM_START);
        dispatch(setAppLoading(false));
        return Promise.resolve(response.data);
      } catch (error: any) {
        dispatch(setAppLoading(false));
        return Promise.reject(error.data);
      }
    };



export const getTrialExam =
  (exam_id: any): AppThunk<any> =>
    async (dispatch) => {
      try {
        dispatch(setAppLoading(true));
        const response = await api.get(API_URL.TRIAL_EXAM_GET(exam_id));
        dispatch(setAppLoading(false));
        return Promise.resolve(response.data);
      } catch (error: any) {
        dispatch(setAppLoading(false));
        return Promise.reject(error.data);
      }
    };


export const completeTrialExam =
  (exam_id: any, exam_answers: any): AppThunk<any> =>
    async (dispatch) => {
      try {
        dispatch(setAppLoading(true));
        const response = await api.post(API_URL.TRIAL_EXAM_FINISH(exam_id), exam_answers);
        dispatch(setAppLoading(false));
        return Promise.resolve(response.data);
      } catch (error: any) {
        dispatch(setAppLoading(false));
        return Promise.reject(error.data);
      }
    };


export const getTrialResult =
  (): AppThunk<any> =>
    async (dispatch) => {
      try {
        dispatch(setAppLoading(true));
        const response = await api.get(API_URL.TRIAL_EXAM_RESULT);
        dispatch(setAppLoading(false));
        return Promise.resolve(response.data);
      } catch (error: any) {
        dispatch(setAppLoading(false));
        return Promise.reject(error.data);
      }
    };


export const trialUserUpgrade =
  (requestData: any): AppThunk<any> =>
    async (dispatch) => {
      try {
        dispatch(setAppLoading(true));
        const response = await api.post(API_URL.TRIAL_USER_UPGRADE, requestData);
        dispatch(setAppLoading(false));
        return Promise.resolve(response.data);
      } catch (error: any) {
        dispatch(setAppLoading(false));
        return Promise.reject(error.data);
      }
    };


export const userExamFlowReset =
  (user_id: any): AppThunk<any> =>
    async (dispatch) => {
      try {
        dispatch(setAppLoading(true));
        const response = await api.get(API_URL.USER_RESET_EXAM(user_id));
        dispatch(setAppLoading(false));
        return Promise.resolve(response.data);
      } catch (error: any) {
        dispatch(setAppLoading(false));
        return Promise.reject(error.data);
      }
    };



export default WebProfileSlice.reducer;
